export default function Heading({results, name}) {
    return (
        <div className="heading">
            <h1>Moje wyniki</h1>
            <table>
                <tbody>
                    <tr>
                        <td>Imię:</td>
                        <td>{name}</td>
                    </tr>
                    <tr>
                        <td>Pozyskane kontakty:</td>
                        <td>{results}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}